export default __webpack_public_path__ + "static/media/robin-and-sam.65b6f46c.jpg";